export class IdStorage {
  usedIds = [];
  lastId = 0;

  constructor(options) {
    ({ suffix: this.suffix = '_id' } = { options });
  }

  createId() {
    let id = this._generateId();
    while (this.usedIds.includes(id)) {
      id = this._generateId();
    }

    return id;
  }

  _generateId() {
    this.lastId++;
    return this.lastId + this.suffix;
  }
}
